<script setup lang="js">
import {ref} from "vue";

const dblogo = ref('https://cos5.51tgqj.com/techming/img/dblogo@2x.png')
const wxlogo = ref('https://cos5.51tgqj.com/techming/img/wxlogo@2x.png')
const qqlogo = ref('https://cos5.51tgqj.com/techming/img/qqlogo@2x.png')
const txsp = ref('https://cos5.51tgqj.com/techming/img/txsp@2x.png')
const xhs = ref('https://cos5.51tgqj.com/techming/img/xhs@2x.png')
const dy = ref('https://cos5.51tgqj.com/techming/img/dy@2x.png')
const dspp = ref('https://cos5.51tgqj.com/techming/img/dspp@2x.png')
const dh = ref('https://cos5.51tgqj.com/techming/img/dh@2x.png')
const sj = ref('https://cos5.51tgqj.com/techming/img/sj@2x.png')





</script>

<template>
    <div class="container mx-auto py-[1rem] md:py-[1rem] sm:py-[1rem] lg:py-[1.5rem]">
      <div class="w-full my-4 md:my-4 sm:my-4 lg:my-8 border-s border-[#011A81] flex justify-center relative">
        <div class="w-full h-[0.08rem] bg-[#54C3F1] absolute translate-y-1/2 top-1/2"></div>
        <div class=" w-1/4">
          <el-image class="w-full bg-[#011A81]" :src="dblogo"/>
        </div>
      </div>
      <div class="flex justify-between flex-wrap px-1 items-center">
        <div class="w-full md:w-full lg:w-7/12 flex justify-between px-14 md:px-14 lg:px-0">
          <text class="text-white text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem]">关注我们：</text>
          <el-image :src="wxlogo" class="h-[2rem] w-[2.5rem]"/>
          <el-image :src="qqlogo" class="h-[2rem] w-[2.5rem]"/>
          <el-image :src="txsp" class="h-[2rem] w-[2.5rem]"/>
          <el-image :src="xhs" class="h-[2rem] w-[2.5rem]"/>
          <el-image :src="dy"class="h-[2rem] w-[2.5rem]"/>
          <el-image :src="dspp" class="h-[2rem] w-[2.5rem]"/>
        </div>
        <div class="w-full md:w-full lg:w-5/12 lg:pl-16 px-24 md:px-24 lg:px-0 flex justify-between mt-6 md:mt-6 lg:mt-0">
          <div class="text-white text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem]">
            <el-image :src="dh" class="h-[2rem] w-[2rem]"/>
            023-6808 6763
          </div>
          <div class="text-white text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem]">
            <el-image :src="sj" class="h-[2rem] w-[2.5rem]"/>
            137 0830 6888
          </div>
        </div>

      </div>
      <div class="flex lg:flex-row md:flex-col flex-col justify-center mt-10">
        <text class="text-white text-xl px-2 text-center  text-[1.1rem] md:text-[1.1rem] lg:text-[1.3rem]">重庆铭匠网络科技有限公司 copyright©2025 铭匠网络科技</text>
        <text class="text-white text-xl text-center text-[1.1rem] md:text-[1.1rem] lg:text-[1.3rem]"><a href="https://beian.miit.gov.cn/" target="_blank">备案号：渝ICP备2021014821号-2</a></text>
      </div>
    </div>
</template>

<style scoped>

</style>
